import React from 'react';
import OrganizationTree from '../../OrganizationTree';
import Modal from '../../Modal';

/**
 * 管理 - 組織階層管理ページ
 */
function Organizations({
  selectedCompany,
  organizationUnits,
  handleAddOrganization,
  handleEditOrganization,
  handleDeleteOrganization,
  showOrgModal,
  setShowOrgModal,
  editingOrg,
  parentOrg,
  orgForm,
  setOrgForm,
  handleSaveOrganization,
  theme
}) {
  return (
    <div>
      <div style={{ marginBottom: '20px' }}>
        <h2>組織階層管理</h2>
      </div>

      {selectedCompany ? (
        <>
          <OrganizationTree
            company={selectedCompany}
            organizationUnits={organizationUnits}
            onAdd={handleAddOrganization}
            onEdit={handleEditOrganization}
            onDelete={handleDeleteOrganization}
          />

          {/* 組織登録・編集モーダル */}
          {showOrgModal && (
            <Modal
              title={editingOrg ? '組織情報編集' : '組織追加'}
              onClose={() => setShowOrgModal(false)}
              width="500px"
            >
                {parentOrg && (
                  <div style={{ marginBottom: '16px', padding: '12px', background: theme === 'dark' ? '#2f3844' : '#f7fafc', borderRadius: '6px', fontSize: '14px' }}>
                    親組織: <strong>{parentOrg.organization_unit_name || selectedCompany.company_name}</strong>
                    {editingOrg && (
                      <div style={{ color: '#718096', fontSize: '12px', marginTop: '4px' }}>
                        親組織を変更する場合は、一度キャンセルして階層から再度追加してください
                      </div>
                    )}
                  </div>
                )}
                {!parentOrg && (
                  <div style={{ marginBottom: '16px', padding: '12px', background: theme === 'dark' ? '#3a2f1f' : '#fffaf0', borderRadius: '6px', fontSize: '14px', borderLeft: '4px solid #ed8936' }}>
                    {editingOrg ? 'ルート組織として登録されています' : 'ルート組織を登録します'}
                  </div>
                )}

                <div className="form-group">
                  <label>組織タイプ *</label>
                  <select
                    value={orgForm.organization_unit_type}
                    onChange={(e) => setOrgForm({ ...orgForm, organization_unit_type: e.target.value })}
                  >
                    <option value="department">部門</option>
                    <option value="division">事業部</option>
                    <option value="section">課</option>
                    <option value="team">チーム</option>
                    <option value="group">グループ</option>
                    <option value="office">事業所</option>
                    <option value="factory">工場</option>
                    <option value="other">その他</option>
                  </select>
                </div>

                <div className="form-group">
                  <label>組織コード</label>
                  <input
                    type="text"
                    value={orgForm.organization_unit_code}
                    onChange={(e) => setOrgForm({ ...orgForm, organization_unit_code: e.target.value })}
                    placeholder="例: DEP001"
                  />
                </div>

                <div className="form-group">
                  <label>組織名 *</label>
                  <input
                    type="text"
                    value={orgForm.organization_unit_name}
                    onChange={(e) => setOrgForm({ ...orgForm, organization_unit_name: e.target.value })}
                    placeholder="例: 製造部"
                  />
                </div>

                <div className="form-group">
                  <label>並び順</label>
                  <input
                    type="number"
                    value={orgForm.sort_order}
                    onChange={(e) => setOrgForm({ ...orgForm, sort_order: parseInt(e.target.value) || 0 })}
                  />
                </div>

                <div className="form-group">
                  <label style={{ display: 'flex', alignItems: 'center' }}>
                    <input
                      type="checkbox"
                      checked={orgForm.is_active}
                      onChange={(e) => setOrgForm({ ...orgForm, is_active: e.target.checked })}
                      style={{ marginRight: '8px', width: 'auto' }}
                    />
                    有効
                  </label>
                </div>

                <div className="modal-actions">
                  <button className="btn btn-secondary" onClick={() => setShowOrgModal(false)}>
                    キャンセル
                  </button>
                  <button 
                    className="btn btn-primary" 
                    onClick={handleSaveOrganization}
                    disabled={!orgForm.organization_unit_name}
                  >
                    {editingOrg ? '更新' : '追加'}
                  </button>
                </div>
            </Modal>
          )}
        </>
      ) : (
        <div style={{ padding: '40px', textAlign: 'center', color: '#718096' }}>
          会社管理画面から「組織階層」ボタンをクリックして、組織階層を管理してください。
        </div>
      )}
    </div>
  );
}

export default Organizations;
